export const productEntityKeys = {
  planner: {
    getProductEntities: (searchTerm: string, offset: string) =>
      ['planner', 'get-product-entities', searchTerm, offset] as const,
    createProductEntity: (productEntityName: string) =>
      ['planner', 'create-product-entity', productEntityName] as const,
  },
} as const;
